const VERSION = typeof "3.4.4" !== 'undefined' ? "3.4.4" : 'latest';
const DEFAULT_LAS_OPTIONS = {
  las: {
    shape: 'mesh',
    fp64: false,
    skip: 1,
    colorDepth: 8
  }
};
export const LASLoader = {
  name: 'LAS',
  id: 'las',
  module: 'las',
  version: VERSION,
  worker: true,
  extensions: ['las', 'laz'],
  mimeTypes: ['application/octet-stream'],
  text: true,
  binary: true,
  tests: ['LAS'],
  options: DEFAULT_LAS_OPTIONS
};
export const _typecheckLoader = LASLoader;
//# sourceMappingURL=las-loader.js.map